"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = exports.applyTemplate = exports.parseOrigin = void 0;
// 简单的模板字符串替换方法
var template = function (templateStr, regexp) {
    if (regexp === void 0) { regexp = /\{(\w+)\}/; }
    return function (params) {
        return templateStr.replace(new RegExp(regexp, 'g'), function (match, p1) {
            return params[p1] || '';
        });
    };
};
// https://confluence.shopee.io/pages/viewpage.action?spaceKey=SPFOODY&title=5.5+Domain+Management
// 解析 Foody 域名，判断是否是 live 环境、解析 cid、env 等信息
var parseOrigin = function (arg) {
    var _a;
    // 如果不是 window 环境，直接返回
    if (typeof window === 'undefined')
        return {};
    // @ts-ignore
    var origin = arg || (window === null || window === void 0 ? void 0 : window.__origin__) || ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin); // eslint-disable-line no-restricted-globals
    var reg = /^(https?):\/\/([.\w-_]*?)\.(([^.]+)\.)?shopee\.([.\w-_]+)$/;
    if (reg.test(origin)) {
        return {
            protocol: RegExp.$1,
            module: RegExp.$2,
            isLive: !RegExp.$3,
            envDot: RegExp.$3,
            env: RegExp.$4,
            cid: RegExp.$5,
        };
    }
    return {};
};
exports.parseOrigin = parseOrigin;
;
// 路径模板替换
var applyTemplate = function (path, origin) {
    var compiled = template(path);
    return compiled(exports.parseOrigin(origin));
};
exports.applyTemplate = applyTemplate;
var reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
var isUrl = function (path) { return reg.test(path); };
exports.isUrl = isUrl;
// export default { parseOrigin, isUrl };
